const UserViewedOutcomesPage = "User_viewed_outcomes_page";
export default UserViewedOutcomesPage;
